enum BillingsTaxiUnbilledRouteListingViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default BillingsTaxiUnbilledRouteListingViewMode;
